/**
 * Updates current url query parameters without reloading page in browser
 */
export const updateQueryParameters = (newQueryParameters: URLSearchParams) => {
  const newUrl = new URL(window.location.toString());
  newUrl.search = newQueryParameters.toString();

  window.history.replaceState('', document.title, newUrl);
};
